<h5 *ngIf="data.title" nxHeadline="subsection-medium" class="align-center font-24
  margin-bottom-32">{{data.title | translate}}</h5>
<div class="container1120" [ngClass]="data.globalClassName">
    <qbe-panel-component [formGroup]="Form" class="formClass">
        <div nxRow nxRowAlignItems="center" class="align-center mobifix" [ngClass]="data.className" style="margin-left: 0;margin-right: 0 ;">
            <div nxCol="12" class="margin0">
                <h2 class="align-center margin-top-48 margin-bottom-24">{{data.heading | translate}}
                </h2>
                <button [ngClass]="data.link.classList" [nxButton]="data.link.type" *ngIf="data.link && data.expired" [routerLink]="data.link.path" style="margin-bottom: 30px;">
                    {{data.link.label | translate}}
                </button>
            </div>
            <div nxCol="12" *ngIf="data.subHeading">
                <div class="width-676">

                    <ng-container *ngIf="{
            printObject: sharedService.printObject$ | async
            } as o">
                        <!--Changing the data?progress check as action field does not exist-->
                        <!-- <span *ngIf="data?.progress?.action == 'print'" class="enter-phone
              translated-paragraph"> -->
                        <span *ngIf="data?.finish === true" class="enter-phone
              translated-paragraph">
              {{ data.subHeading | translate}} <span
                  class="font-bold">{{policyNum}}</span> {{ 'createOffer.subHeading1' | translate}}</span>
                        <span *ngIf="data?.finish !== true" class="enter-phone
                  translated-paragraph">
                  {{ data.subHeading | translate}} </span>
                    </ng-container>
                </div>
            </div>
            <div nxCol="12, 12, 6" colOffset="0, 0, 3" *ngIf="data.showMobile">
                <nx-formfield>
                    <app-phone-numbers [mobilePhone]="mobilePhone" [mobileCode]="mobileCode" trackingPath="user.mobilePhone" >
                    </app-phone-numbers>
                    <span nxFormfieldHint>+35988 488 76xx</span>
        
                </nx-formfield>

            </div>
            <div nxCol="12, 12, 7" colOffset="0, 0, 3" style="margin:0 30px ;" *ngIf="data.expired">
                <div class="sendErrorContainer">
                    <qbe-illustration class="display-desktop" name="woman-in-front-of-computer">
                    </qbe-illustration>
                </div>
                <qbe-illustration class="display-mobile" name="woman-in-front-of-computer">
                </qbe-illustration>
            </div>

            <div nxCol="12, 12, 7" colOffset="0, 0, 3" [ngStyle]="{'margin-left':
        (data.sendError || data.mobileError) ? '5%' : 'auto', height:
        (data.sendError || data.mobileError) ? '155px' : 'auto'}" style="margin:
        0 auto;">
                <div *ngIf="data.sendError || data.mobileError " class="sendErrorContainer">
                    <qbe-illustration class="display-desktop" *ngIf="data.sendError" name="woman-in-front-of-computer">
                    </qbe-illustration>
                    <qbe-illustration *ngIf="data.mobileError" name="woman-with-sunhat-talking-on-the-phone">
                    </qbe-illustration>
                    <button [ngClass]="data.link.classList" [nxButton]="data.link.type" *ngIf="data.link && !data.link.action && !data.link.icon && !data.expired &&
            (data.sendError || data.mobileError)" [disabled]="data.link.disabled
            && !Form.valid" (click)="sendError()">
            {{data.link.label | translate}}
          </button>
                </div>
                <qbe-illustration class="display-mobile" *ngIf="data.paymentError " name="woman-in-front-of-computer">
                </qbe-illustration>
                <button [ngClass]="data.link.classList" [nxButton]="data.link.type" *ngIf="data.link && !data.link.action && !data.paymentError &&
          !data.link.icon && !data.sendError && !data.mobileError && !data.expired " [disabled]="data.link.disabled && !Form.valid" [routerLink]="data.link.path">
          {{data.link.label | translate}}
        </button>

                <button class="payment-error-button" [nxButton]="data.link.type" *ngIf="data.paymentError && !data.expired" [disabled]="data.link.disabled &&
          !Form.valid" [routerLink]="data.link.path">
          {{data.link.label | translate}}
        </button>
                <ng-container *ngIf="data.isPayment">
                    <ng-container *ngIf="(proposalService.calculatedPremiums$ | async) |
            onlyMtpl as data; else paymentButton">
                        <div class="creditCard">
                            <qbe-radio-button class="radio-button" [selected]="selected" (click)="selected= !selected" (click)="selected===true? trackService.pushEventTracking('product.paymentMethod', 'card') : trackService.pushEventTracking('product.paymentMethod', '')" >
                                <qbe-icon icon="credit-card-o"></qbe-icon><br>
                                {{'payment.creditCard' | translate}}
                            </qbe-radio-button>
                        </div>
                    </ng-container>
                    <ng-template #paymentButton>
                        <div class="creditCard">
                            <qbe-radio-button class="radio-button" [selected]="selected" (click)="selected= !selected" (click)="selected===true? trackService.pushEventTracking('product.paymentMethod', 'card') : trackService.pushEventTracking('product.paymentMethod', '')">
                                <qbe-icon icon="credit-card-o"></qbe-icon><br>
                                {{'payment.creditCard' | translate}}
                            </qbe-radio-button>
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="data?.link?.action == 'print' || data?.link?.action
          == 'new-print' || data?.finish">
                    <ng-container *ngIf="{
            printObject: sharedService.printObject$ | async
            } as o">

                        <!--<button [ngClass]="data.link.classList" [nxButton]="data.link.type" style="margin-top: 32px;"
                    [disabled]="data.link.disabled && !Form.valid"
                    (click)="handleClick(data.link.action, o.printObject)">
              {{data.link.label | translate}}
            </button>-->
                    </ng-container>
                    <div class="over-button-div" *ngIf="data?.link?.action == 'print' ||
            data?.link?.action == 'new-print' || data?.finish">
                        <div class="button-div">
                            <ng-container *ngIf="data?.finish">
                                <!-- <h5 *ngIf="policyId" nxHeadline="subsection-medium" class="align-center">{{'createOffer.subHeading' | translate}}
                                    <strong>{{policyId}}</strong> {{'createOffer.subHeading1' | translate}}
                                </h5> -->
                                <button nxButton="secondary medium" type="button" (click)="openModalEvrotrust()">{{'createOffer.btnText' | translate}}</button>
                            </ng-container>
                            <button *ngIf="isRegistered" nxButton="primary" type="button" (click)="btnClick2()">{{
                "createOffer.yourAccount"
                | translate}}</button>
                            <button *ngIf="!isRegistered" nxButton="primary" type="button" (click)="clickToMyAllianz()">{{
                "createOffer.myAllianz"
                | translate}}</button>
                        </div>
                        <div class="woman-cheering image-div">
                            <qbe-illustration
                            name="womanCheeringInFrontOfComputer"
                            class="img"
                            width = "298.7px"
                            style="display: flex; justify-content: center;"
                          ></qbe-illustration>                       
                         </div>
                    </div>
                </ng-container>
                <div class="nx-margin-top-3xl flex" *ngIf="data.image">
                    <qbe-illustration [name]="data.image" class="outer-top-element-left-illustration"></qbe-illustration>
                </div>
            </div>
        </div>
        <div class="nx-margin-top-3xl flex" *ngIf="data.paymentError" class="payment-error-image">
            <qbe-illustration *ngIf="data.paymentError" name="woman-in-front-of-computer">
            </qbe-illustration>
        </div>

    </qbe-panel-component>
    <div *ngIf="data?.link?.action == 'print' || data?.link?.action ==
    'new-print'
    || data?.finish" class="sent-message">
        <ng-container *ngIf="{
      printObject: sharedService.printObject$ | async
      } as o">
            {{ 'createOffer.bottomText1' | translate}}<span >{{eMail}}</span> <span [innerHTML]="'createOffer.bottomText2' | translate | safeHtml"></span>
            <span style="white-space: nowrap; overflow: hidden;">{{ 'createOffer.bottomText3' | translate}}</span>
            <!--    </ng-container>-->
        </ng-container>
    </div>
</div>

<form ngNoForm style="display: none" name="pay" [action]="boricaUrl" method="POST">
    <input type="text" *ngFor="let property of getBoricaProperties()" [value]="property.value" [name]="property.key" readonly>
    <input #submitFormPayButton type="submit">
</form>


<ng-template #thankYouReg>
    <div class="thank-you-container">
        <center>
            <qbe-illustration
            name="sent"
            class="img-thankYou"
            width = "140px"
            style="display: flex; justify-content: center;"
          ></qbe-illustration>    
        </center>
        <h3 class="thankYou-Header thankYou-Header-popup">{{ "createOffer.myAllianzRegHeader" | translate}}</h3>
        <p class="thankYou-text thankYou-text-popup">{{ "createOffer.myAllianzRegSubHeader" | translate}}</p>
        <center>
            <nx-link (click)="clickToMyAllianzBadMail()">{{ "createOffer.myAllianzRegNewMail" | translate}}</nx-link>
        </center>
        <center><button class="thank-you-button-popup" nxButton="primary" type="button" (click)="closePopUp()">
    OK
</button></center>
    </div>
</ng-template>

<!-- <div (click)="openModal()">Тест</div> -->